import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { Chains } from '@/domains/chain'
import { wagmiSwitchChain } from '@/shared/lib/wagmi/api/wagmiSwitchChain.ts'

export function useSwitchChainFromQuery() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const paramChain = params.get('chain')

    if (paramChain) {
      for (const [name, chain] of Object.entries(Chains)) {
        if (name.toLowerCase() === paramChain.toLowerCase()) {
          wagmiSwitchChain(chain.id)

          params.delete('chain')
          const newSearch = params.toString()
          const newPath = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`

          navigate(newPath, { replace: true })
          break
        }
      }
    }
  }, [location, navigate])
}
